import frame from "./frame.png";
import bg from "./bg.png";

const Frames = [frame, bg];
export default Frames;
